<script>
    import { createEventDispatcher } from 'svelte';
    import { navigate, link } from "svelte-routing";
    import { appSettings, personen } from "../../stores";

    const dispatch = createEventDispatcher();

    function last () {
        if ($appSettings.personIndex < personen.length) {
            $appSettings.personIndex--;
        } else {
            $appSettings = personen.length;
        }
        navigate("/personen/"+personen[$appSettings.personIndex].id);
        dispatch('reload', {id: personen[$appSettings.personIndex].id});
    }

    function next () {
        if ($appSettings.personIndex < personen.length-1) {
            $appSettings.personIndex++;
        } else {
            $appSettings = 0;
        }
        navigate("/personen/"+personen[$appSettings.personIndex].id);
        dispatch('reload', {id: personen[$appSettings.personIndex].id});
    }

    function up () {
        navigate("/personen");
    }

</script>

<div class="spacer"></div>
<div class="container">
    <div class="narrow">        
        <button on:click={last} disabled={$appSettings.personIndex<=0} class="button round">
            <i class="icon icon-angle-double-left"></i>
        </button>
        <!-- <button on:click={up} class="button round">
            <i class="icon icon-th"></i>
        </button> -->
        <a href="/personen" use:link>Personen</a>
        <button on:click={next} disabled={$appSettings.personIndex>=personen.length-1} class="button round">
            <i class="icon icon-angle-double-right"></i>
        </button>
    </div>
</div>

<style>
    .container {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        box-sizing: border-box;
        z-index: 1;
        flex-grow: 0;
        flex-shrink: 0;
        background: #1A1A1A;
        /* background: radial-gradient(circle at bottom, #242424 0%, #1A1A1A 100%); */
        box-shadow: 0 0 20px #00000050;
    }

    .narrow {
        color: white;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        max-width: 40rem;
        margin-left: auto;
        margin-right: auto;
        /* background: radial-gradient(circle at bottom, #303030 5%, #242424 30%, #1A1A1A 70%); */
        background-image: url("/images/bg/bg_gradient_25-min.png");
        background-position: center bottom;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .button {
        display: block;
        background-color: transparent;
        box-shadow: none;
        border-radius: 50%;
        width: 3rem;
        height: 2.5rem;
        padding: 0.2rem;
        margin: 0.75rem;
        position: relative;
        color: #eee;
    }

    .spacer {
        height: 3.5rem;
    }
</style>